// extracted by mini-css-extract-plugin
export default {"spinner__con":"styles_spinner__con__3+S6f","scaleUpDown":"styles_scaleUpDown__VaGjv"};